import { replace } from 'react-router-redux';
import { put, fork, takeEvery, all } from 'redux-saga/effects';
import { get, map } from 'lodash';

import { showNotification } from 'modules/snackbar';
import {
  FETCH_APPLICATION_FAILURE,
  FETCH_APP_PACKAGE_COMPONENT_LIST_BY_TYPE,
  UPDATE_SUCCESS,
  UPDATE_APPLICATION_COMPONENTS_SUCCESS,
  DELETE_CME_SUCCESS,
  UPDATE_FAILURE,
  fetchComponentsOfType,
  fetchingComponentsOfType,
  donefetchingComponentsOfType
} from 'modules/application';
import { appPackageComponentTypes } from 'modules/application/constants';

// ***
// Permissions checks for application
// ***
function* onApplicationLoadFailure(action) {
  const message = {
    not_found: 'The specified application was not found.',
    default: 'The specified application was not found.'
  }[get(action.payload, 'errors[0].name', 'default')];

  yield put(showNotification(message));
  yield put(replace('/applications'));
}

function* watchApplicationPermissions() {
  yield takeEvery(FETCH_APPLICATION_FAILURE, onApplicationLoadFailure);
}

function* fetchAppPkgComponentTypeList(action) {
  const componentType = get(action.payload, 'componentType', '');

  if (!map(appPackageComponentTypes, 'type').includes(componentType)) {
    return;
  }

  yield put(fetchingComponentsOfType());

  try {
    yield put.resolve(fetchComponentsOfType({ componentType, limit: 30 }));
  } catch (e) {
    /* */
  }

  yield put(donefetchingComponentsOfType());
}

function* watchAppPackageComponentTypeSelect() {
  yield takeEvery(
    FETCH_APP_PACKAGE_COMPONENT_LIST_BY_TYPE,
    fetchAppPkgComponentTypeList
  );
}

function* onAppPackageUpdate(action) {
  const message =
    action.type !== UPDATE_FAILURE
      ? 'Application updated successfully.'
      : 'Unable to update application.';

  yield put(showNotification(message));
}

function* watchAppPackageUpdate() {
  yield takeEvery(
    [
      UPDATE_SUCCESS,
      UPDATE_APPLICATION_COMPONENTS_SUCCESS,
      UPDATE_FAILURE,
      DELETE_CME_SUCCESS
    ],
    onAppPackageUpdate
  );
}

export default function* root() {
  yield all([
    // when the details page is loaded, make sure user has permissions
    // to view the specified application, and that it exists
    fork(watchApplicationPermissions),
    fork(watchAppPackageComponentTypeSelect),
    fork(watchAppPackageUpdate)
  ]);
}



// WEBPACK FOOTER //
// ./src/client/plugins/applications/modules/details-sagas.js